import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useFormContext } from "react-hook-form";

const Step5 = () => {
  const { t } = useTranslation("common");
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const isMobile = useMobile("md");

  return (
    <div className="mb-3">
      <div className="ms-1 d-flex align-items-center">
        <input
          className="form-check-input cursor mt-0"
          type="checkbox"
          id="approved_terms"
          {...register("approved_terms")}
        />
        <label
          className={`form-check-label cursor ms-2 fs-${
            isMobile ? "md" : "lg"
          }`}
          htmlFor="approved_terms"
        >
          {t("i_agree")}{" "}
          <Link
            href="/help/terms"
            passHref
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(`terms`)}{" "}
          </Link>{" "}
          <span> {t("and")}</span>{" "}
          <Link
            href="/help/privacy"
            passHref
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("privacy_policy")}{" "}
          </Link>
        </label>
      </div>
      <div className="invalid-feedback">
        {t(errors.approved_terms?.message as string)}
      </div>
    </div>
  );
};

export default Step5;
